import { render, staticRenderFns } from "./SliderProtests.vue?vue&type=template&id=e728b08a"
import script from "./SliderProtests.vue?vue&type=script&lang=js"
export * from "./SliderProtests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports